import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../../components/isLoading";
import ReportsTableContainer from "../TableContainer";
import formatReports from "../../../helpers/formatBlog";
import { fetchReportsData } from "../../../redux/reports/index";
import { Button } from "@mui/material";
import { NavLink } from "react-router-dom";
import moment from "moment";

export default () => {
	const reportsData = useSelector((state) => state.reportsGlobalStore);

	const dispatch = useDispatch();

	const [dataState, setDataState] = useState({
		formattedReportsData: [],
		authorRecords: [],
		currentPage: 0,
	});

	useEffect(() => {
		dispatch(fetchReportsData(dataState.currentPage));
	}, [dataState.currentPage]);

	let formattedReportsData = [];

	useEffect(() => {
		for (const report of reportsData.data?.data || []) {
			const formattedData = formatReports(report);
			formattedData.author = report.category;
			formattedData.postDate = moment(report.date).format("ll");
			formattedReportsData.push(formattedData);
		}

		setDataState((prevState) => ({
			...prevState,
			formattedReportsData,
			currentPage: reportsData.data.pagination?.offset || 0,
		}));
	}, [reportsData.data]);

	const onPageChange = (pageNumber) =>
		setDataState((prevState) => ({ ...prevState, currentPage: pageNumber }));

	return (
		<div>
			{reportsData.loading && !reportsData.data[0] ? (
				<Loading />
			) : (
				<>
					<div
						style={{
							padding: "15px",
							float: "right",
						}}
					>
						<Button
							variant="outlined"
							component={NavLink}
							to="/reports/new"
							sx={{
								color: "#E00186",
								border: "1px solid #E00186",
								fontFamily: "Arial",
								"&:hover": {
									color: "#fff",
									backgroundColor: "#E00186",
									border: "1px solid #E00186",
								},
							}}
						>
							Add new Report
						</Button>
					</div>
					<ReportsTableContainer
						noAvatar
						headCells={[
							{ id: "title", rightAlign: false, label: "Title" },
							{ id: "status", rightAlign: true, label: "Status" },
							{ id: "category", rightAlign: true, label: "Category" },
							{ id: "date", rightAlign: true, label: "Date" },
						]}
						isUpdating={reportsData.loading && reportsData.data[0]}
						formattedData={dataState.formattedReportsData}
						hidden={["updated"]}
						title="All Reports"
						pagination={reportsData.data.pagination || {}}
						onPageChange={onPageChange}
					/>
				</>
			)}
		</div>
	);
};
